










import { Component, Prop, Vue } from "vue-property-decorator";
import { IProduct } from "@/models/products";

@Component({
  components: {
    "product-image": () =>
      import("@/components/app/global/products/productImage.vue")
  }
})
export default class CProdMigrationImage extends Vue {
  @Prop({ required: true })
  public oldProduct!: IProduct;

  @Prop({ required: true })
  public newProduct!: IProduct;
}
